export default {
  set: (key, val) => {
    localStorage.setItem(key, JSON.stringify(val))
  },
  remove: (key) => {
    localStorage.removeItem(key)
  },
  get: (key) => {
    if (localStorage.getItem(key) !== null) {
      return localStorage.getItem(key)
    }
  },
  checkIfKeyExists: (key) => {
    return localStorage.getItem(key) !== null
  },
}
